// extracted by mini-css-extract-plugin
export default {"container":"Ge0ZXJlOGipS7krh7AZw","maxWidth":"bf8QEEgMzFuXq5CRzUB_"};